var App = App || {};

App.Base = (function ($) {
    'use strict';

    let bsElements = {};

    let modals = [];
    let modalFlag = false;
    let delegatedModalClickSupportBound = false;


    const $window = $(window),
        $html = $('html'),
        $body = $('body');


    const speedBump = $("#SpeedBump");
    const wealthManagementSpeedbump = $("#WealthManagementSpeedbump");
    const wealthManagementSpeedbumpDomain = "dimebank.accessasc.com";
    let speedBumpExempt = typeof SpeedbumpData !== 'undefined' ? [...SpeedbumpData.ExemptList] : [];

    function BsElements() {

        bsElements = {
            accElements: [...$(".accordion-item[id]")].map(x => `#${x.getAttribute("id")}`),
            tabElements: [...$(".nav-tabs .nav-item[id]")].map(x => `#${x.getAttribute("id")}`),
            offcanvasElements: [...$(".offcanvas")].filter(x => x.getAttribute("id") != "").map(x => `#${x.getAttribute("id")}`)
        };

        const hash = location.hash;
        if (hash) BsElementsExecute(hash);
    }

    function BsElementsExecute(candidate) {

        const pathName = window.location.pathname;
        if (candidate?.startsWith(pathName)) candidate = candidate.slice(pathName.length);

        let bsType = false;

        for (const key in bsElements) {
            if (bsElements[key].includes(candidate)) {
                bsType = key;
            }
        }

        if (bsType == false)
            return false;

        if (bsType == "accElements") {
            const accordionItem = $(candidate);
            accordionItem.find(".collapse").collapse("show");
            accordionItem.find(".accordion-button").trigger("focus");
            $("html, body").animate({ scrollTop: accordionItem.offset().top }, 200);
        }
        else if (bsType == "tabElements") {
            const tab = $(candidate);
            tab.find(".nav-link").tab("show").trigger("focus");
            $("html, body").animate({ scrollTop: tab.offset().top }, 200);
        }
        else if (bsType == "offcanvasElements") {
            const offcanvas = $(candidate);
            offcanvas.offcanvas("show");
        }

        return true;
    }

    function Modals() {

        $.ajax({
            type: "GET",
            url: "/Api/Modals/GetModalUrls",
            success: function (result) {
                modals = [...result];
                const href = location.hash.replace("#", "/").toLowerCase();
                ModalsExecute(href, null);
            }
        })
    }

    function ModalsExecute(href, clicked) {

        if (href !== "" && modals.includes(href))
            href = href;
        else
            return false;

        const fromSolutionsFinder = clicked !== null && clicked.closest(".section-solutions-finder").length > 0;

        $.ajax({
            type: "GET",
            url: href,
            success: function (result) {

                const modalData = {
                    "id": $(result).filter(".modal, .offcanvas").attr("id"),
                    "content": $(result).filter(".modal, .offcanvas").prop("outerHTML")
                };

                $("body").append(modalData.content);
                const modal = $(`#${modalData.id}`);

                if (fromSolutionsFinder) {
                    modal.addClass("modal--teal");
                }

                App.Base.ClickSupport(modal.find("a"));

                let showMethod = null;
                let hiddenEvent = null;

                if (modal.hasClass("modal")) {
                    showMethod = "modal";
                    hiddenEvent = "hidden.bs.modal";
                }
                else if (modal.hasClass("offcanvas")) {
                    showMethod = "offcanvas";
                    hiddenEvent = "hidden.bs.offcanvas";
                }

                modal[showMethod]("show").on(hiddenEvent, function () {
                    if (clicked !== null) {
                        clicked.trigger("focus").trigger("blur");
                    }
                    if (!modalFlag) {
                        $(this).remove();
                    }
                });

            }
        });

        return true;
    }

    function SpeedBumpExecute(clicked) {

        const hostname = clicked[0].hostname;
        const href = clicked.attr("href");

        if (!href || IsUriSchema(href)) {
            return false;
        }

        const hrefLower = href.toLowerCase();
        let selectedSpeedBump = null;

        if (hrefLower.indexOf(wealthManagementSpeedbumpDomain) !== -1) {
            selectedSpeedBump = wealthManagementSpeedbump;
        }
        else if (hostname === location.hostname || $.inArray(hostname, speedBumpExempt) !== -1) {
            return false;
        }
        else {
            selectedSpeedBump = speedBump;
        }

        if (!selectedSpeedBump.length) {
            return false;
        }

        // check to see if speedbump was triggered from a modal
        const modalParent = clicked.parents(".modal").first();
        modalFlag = modalParent.length != 0;
        modalParent.modal("hide");

        selectedSpeedBump.modal("show");
        selectedSpeedBump.find("button[data-speedbump='proceed']")
            .off("click")
            .on("click", function () {
                selectedSpeedBump.modal("hide");
                window.open(href);
            }
            );

        selectedSpeedBump
            .off("hidden.bs.modal")
            .on("hidden.bs.modal", function () {
                clicked.trigger("focus").trigger("blur");
                if (modalFlag) {
                    modalParent.modal("show");
                    modalFlag = false;
                }
            });

        return true;

    }

    function AnchorInModalExecute(clicked) {

        const href = clicked.attr("href");

        if (!href || IsUriSchema(href)) {
            return false;
        }

        let hrefUrl = null;

        try {
            hrefUrl = new URL(href, window.location.href);
        }
        catch {
            return false;
        }

        const hash = hrefUrl.hash;

        if (!hash || hash === "#") {
            return false;
        }

        const normalizePath = function (path) {
            return (path || "/").replace(/\/+$/, "") || "/";
        };

        const hrefPath = normalizePath(hrefUrl.pathname).toLowerCase();
        const currentPath = normalizePath(window.location.pathname).toLowerCase();

        if (hrefUrl.origin !== window.location.origin || hrefPath !== currentPath) {
            return false;
        }

        const container = clicked.closest(".modal.show, .offcanvas.show");

        if (!container.length) {
            return false;
        }

        let hiddenEvent = null;
        let hideMethod = null;

        if (container.hasClass("modal")) {
            hiddenEvent = "hidden.bs.modal";
            hideMethod = "modal";
        }
        else if (container.hasClass("offcanvas")) {
            hiddenEvent = "hidden.bs.offcanvas";
            hideMethod = "offcanvas";
        }

        if (!hiddenEvent || !hideMethod) {
            return false;
        }

        let hasNavigated = false;

        const navigateToHash = function () {
            if (hasNavigated) {
                return;
            }

            hasNavigated = true;

            if (BsElementsExecute(hash) != true) {
                const targetId = decodeURIComponent(hash.slice(1));
                const target = document.getElementById(targetId);

                if (location.hash !== hash) {
                    location.hash = hash;
                }

                if (target) {
                    $("html, body").animate({ scrollTop: $(target).offset().top }, 200);
                }
            }
        };

        container.one(hiddenEvent, navigateToHash);

        container[hideMethod]("hide");

        // Fallback in case hide event timing is interrupted by other modal behaviors.
        setTimeout(navigateToHash, 450);
        return true;
    }

    function ClickSupport(selector) {

        const clickHandler = function (e) {

            const href = $(this).attr("href");

            if (AnchorInModalExecute($(this)) == true) {
                e.preventDefault();
                return false;
            }

            if (BsElementsExecute(href) == true) {
                e.preventDefault();
                return false;
            }

            if (ModalsExecute(href, $(this)) == true) {
                e.preventDefault();
                return false;
            }

            if (SpeedBumpExecute($(this)) == true) {
                e.preventDefault();
                return false;
            }
        };

        selector.off("click.appBaseClickSupport").on("click.appBaseClickSupport", clickHandler);

        if (!delegatedModalClickSupportBound) {
            $(document)
                .off("click.appBaseModalDelegated")
                .on("click.appBaseModalDelegated", ".modal a, .offcanvas a", clickHandler);
            delegatedModalClickSupportBound = true;
        }
    }

    function IsUriSchema(href) {

        const uriSchemes = ["javascript:", "mailto:", "tel:"];

        for (var i in uriSchemes) {
            if (href.indexOf(uriSchemes[i]) > -1) {
                return true;
            }
        }
        return false;
    }

    function RichTextResponsiveTables(selector) {
        selector.each(function () {
            if (!$(this).parent().hasClass("table-responsive")) {
                $(this).wrap("<div class=\"table-responsive\"></div>")
            }
        });
    }

    function WidgetAnimations(selector) {
        selector.each(function () {
            const widget = $(this);

            if (widget.hasClass("disable-animations")) {
                return;
            }

            widget.ZagScrollAnimate({
                offset: 75,
                targets: [{ selector: ".container", type: "animate_fadeInUp", stagger: 0 }],
                overflow: false
            });
        });
    }

    // https://davidwalsh.name/query-string-javascript
    function GetUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };

    function RegisterCopyButton(options) {
        var $btn = $(options.buttonSelector);
        var $status = $(options.statusSelector);

        if (!$btn.length) return;

        $btn.off('click.copyUtility').on('click.copyUtility', function () {
            var valueToCopy = $btn.data(options.dataKey).toString().trim();
            CopyToClipboard(valueToCopy, $status, options.successMessage, options.errorMessage);
        });
    }

    function CopyToClipboard(text, $status, successMessage, errorMessage) {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text)
                .then(function () {
                    AnnounceStatus($status, successMessage, 3000);
                })
                .catch(function () {
                    FallbackCopy(text, $status, successMessage, errorMessage);
                });
        } else {
            FallbackCopy(text, $status, successMessage, errorMessage);
        }
    }

    function FallbackCopy(text, $status, successMessage, errorMessage) {
        var $temp = $('<textarea>');
        $('body').append($temp);
        $temp.val(text).select();
        var success = document.execCommand('copy');
        $temp.remove();

        if (success) {
            AnnounceStatus($status, successMessage, 3000);
        } else {
            AnnounceStatus($status, errorMessage, 5000);
        }
    }

    function AnnounceStatus($status, message, delay) {
        $status.text(message);
        setTimeout(function () {
            $status.text('');
        }, delay);
    }

    const addOverlay = () => {
        var $overlay = $('<div class="offcanvas-backdrop fade"></div>');
        if (!$body.find('.overlay').length) {
            $body.append($overlay);
            $overlay.addClass('show');
            $body.addClass('modal-open');
            $body.addClass("overlay-open");
        }
        $overlay.on('click', removeOverlay);

    }

    const removeOverlay = () => {
        const $overlay = $('.offcanvas-backdrop');
        $overlay.removeClass('show');

        // Delay removal for transition effect
        setTimeout(() => $overlay.remove(), 150);

        // Unlock scroll + hide panel
        $body.removeClass('modal-open');
        $body.removeClass("overlay-open");
    }

    return {
        $window: $window,
        $html: $html,
        $body: $body,
        addOverlay: addOverlay,
        removeOverlay: removeOverlay,
        BsElements: BsElements,
        Modals: Modals,
        ClickSupport: ClickSupport,
        RichTextResponsiveTables: RichTextResponsiveTables,
        WidgetAnimations: WidgetAnimations,
        GetUrlParameter: GetUrlParameter,
        RegisterCopyButton: RegisterCopyButton,
        CopyToClipboard: CopyToClipboard
    };

})(jQuery);

$(function () {
    App.Base.BsElements();
    App.Base.Modals();
    App.Base.ClickSupport($("a"));
    App.Base.RichTextResponsiveTables($(".rich-text table.table"));
    App.Base.WidgetAnimations($(".widget:not([class*='cmp']):not(.widget-locations):not(.widget-hero):not(.widget-resources):not(.disable-animations)"));
});